module.exports = __webpack_public_path__ + "static/img/12.e9f1481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/12.png
// module id = a7MX
// module chunks = 0